import React, { Component } from 'react';
import cross from '../../../assets/images/close_popup.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import Upload from '../../shared/Upload';
import '../../../css/advertisement/AdvertisementData.css';
import Loader from 'react-loader';
import 'react-calendar/dist/Calendar.css';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
// import { store } from '../../../redux/_helpers/store';
// import {successLoader} from '../../../redux/_actions/loader.action';
class EditAdvertisementDataViaSlot extends Component {
  constructor(props) {
    super(props)
    this.state = {
      url: '',
      effectiveDateCalendar: new Date(),
      expiryDateCalendar: new Date(),
      advertisementData: this.props.advertisementData,
      advertisementName: '',
      imageUploadLink: '',
      imageLink: '',
      isUploadDisabled: true,
      isDeleteDisabled: false,
      effectiveDateCopy: "",
      expiryDateCopy: "",
      effectiveDateFormateCopy: '',
      loaderTime: true,
      pageDisable: true,
      isEditViaSlot: this.props.isEditViaSlot,
    }

  }
  componentDidMount = () => {
    this.setState({ advertisementName: this.state.advertisementData.aDCompany });
    this.setState({ url: this.state.advertisementData.aDLink });
    this.setState({ effectiveDateCalendar: this.getDate(this.state.advertisementData.fromDate) });
    this.setState({ effectiveDateCopy: this.state.advertisementData.fromDate });
    this.setState({ expiryDateCopy: this.state.advertisementData.toDate });
    this.setState({ expiryDateCalendar: this.getDate(this.state.advertisementData.toDate) });
    this.setState({ imageLink: this.props.decodeUrl });
    this.setState({ imageUploadLink: this.state.advertisementData.aDImageMobileLink });
    let fromDateParts = this.state.advertisementData.fromDate.split("/");
    let fromDateFormate = new Date(fromDateParts[2], fromDateParts[1] - 1, fromDateParts[0]).toString();
    this.setState({ effectiveDateFormateCopy: fromDateFormate })
    this.setState({ loaderTime: this.state.imageLink != undefined ? false : true, pageDisable: this.state.imageLink != undefined ? false : true })
    // this.state.imageLink !== undefined ? store.dispatch(successLoader(true)) : store.dispatch(successLoader(false))
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ loaderTime: this.state.imageLink != undefined ? false : true, pageDisable: this.state.imageLink != undefined ? false : true })
    // this.state.imageLink !== undefined ? store.dispatch(successLoader(true)) : store.dispatch(successLoader(false))
    this.setState({ imageLink: this.props.decodeUrl });
    console.log('componentWillReceiveProps', nextProps);
    this.setState(nextProps);
  }
  getTime = (timeStamp) => {
    return new Date(Number(timeStamp)).toString().split(' ')[4].substring(0, 5);
  }
  getDate = (dateString) => {
    //   split the date in order to get day, month and year separately and then use it in another constructor - Date(year, month, day)
    let dateParts = dateString.split("/");
    // month is 0-based, that's why we need dataParts[1] - 1
    let date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]).toString();
    // let date = new Date(Number(dateString)).toString();
    let day = date.split(' ')[2];
    let month = date.split(' ')[1];
    let year = date.split(' ')[3];
    return `${day}-${month}-${year}`;
  }
  getDateFormate = (dateString) => {
    let date = new Date(Number(dateString)).toString();
    let day = date.split(' ')[2];
    let month = date.split(' ')[1];
    let year = date.split(' ')[3];
    return `${day}-${month}-${year}`;
  }
  setImageUploadLink = (imagePathURL) => {
    this.setState({ imageUploadLink: imagePathURL })
  }
  removeImageUploadedLink = () => {
    this.setState({ imageUploadLink: '' })
    console.log("ffff", this.state.imageUploadLink)
  }
  validateFormFields = () => {
    return this.state.advertisementName.length > 0 &&
      this.state.url.length > 0 &&
      this.state.imageUploadLink.length > 0
  };
  render() {
    return (
      <div class="advertisementModalOuter" id={this.state.pageDisable ? "disabletrue" : ""}>
        <MetaDecorator title={TitleDescription.editAdvertisementDataViaSlotPageTitle} description={TitleDescription.editAdvertisementDataViaSlotPageDescription} />
        <div class="advertisementModalInner" >
          <Loader
            loaded={!this.state.loaderTime}
            lines={10}
            length={10}
            width={10}
            radius={10}
            corners={1}
            rotate={0}
            direction={1}
            color="#000"
            speed={1}
            trail={60}
            shadow={false}
            hwaccel={false}
            className='spinner'
            zIndex={2e9}
            top="50%"
            left="50%"
            scale={1.0}
            loadedClassName="loadedContent"
          />
          <div className='advertisementcross'>
            <img src={cross} width="21" height="21" onClick={this.props.onClick} class="d-inline-block align-top" alt="" loading="lazy" />
          </div>
          <div class="advertisementupperdiv">
            <small class="advertisementTitle">
              Advertisement
          </small>
          </div>
          <div>
            <div class="advertisementlowerdiv" >
              <div class="advertisementlowerin">
                <div class="advertisementContainer">
                  <div class="advertisementLeftPart">
                    <div className="imageTextContainer">
                      <p className="imageText">Image*</p>
                    </div>
                    <div className="imageTextContainer">
                      <div>
                        <Upload
                          idupload="imageUpload"
                          output="imageOutput"
                          setImageLink={this.setImageUploadLink}
                          src={this.state.imageLink}
                          isUploadDisabled={this.state.isUploadDisabled}
                          isDeleteDisabled={this.state.isDeleteDisabled}
                          handleRemove={this.removeImageUploadedLink}
                          uploadDelete={this.props.isEditViaSlot}
                        />
                      </div>
                    </div>
                  </div>
                  <div class="advertisementRightPart">
                    <div class="advertisementCompanyContainer">
                      <small class="adLabel">Advertising Company</small>
                      <input readOnly class="copyInput" type="text" placeholder="Enter company name" value={this.state.advertisementName}></input>
                    </div>
                    <div className="fromtoContainer">
                      <div>
                        <small class="adLabel">Effective Date</small>
                        <div className="fromtoTextinput">
                          <div class="advertisementDateInput">
                            <input class="advertisementinputlbor" placeholder="DD/MM/YYYY" value={this.state.effectiveDateCalendar}></input>
                          </div>
                          <img class="pl-2 pr-2" src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block mr-1 " alt="" loading="lazy" alt=""
                          />
                        </div>
                      </div>
                      <div>
                        <small class="adLabel">Expiry Date</small>
                        <div className="fromtoTextinput">
                          <div class="advertisementDateInput">
                            <input class="advertisementinputlbor" placeholder="DD/MM/YYYY" value={this.state.expiryDateCalendar}></input>
                          </div>
                          <img class="pl-2 pr-2" src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block mr-1" alt="" loading="lazy" alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="advertisementUrlContainer">
                      <small class="adLabel">URL</small>
                      <input readOnly class="urlInput" placeholder="Enter your message" value={this.state.url}></input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="advertisementbefore">
                <div>
                  <p className="req">*Requirements:</p>
                  <pre className="reqText">
                    Type: <span className="reqValue">jpeg, jpg, png;</span> <br />
                File Size: <span className="reqValue">2 MB (Maximum);</span> <br />
                Dimensions: <span className="reqValue">1440 x 500 pixels (Minimum)</span>
                  </pre>
                </div>
                <div class="advertisementafter">
                  <button class="advertisementPublishButton"
                    disabled={this.validateFormFields()}>
                    <small class="advertisementSubmitText">Publish</small>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default EditAdvertisementDataViaSlot;